module.exports = __webpack_public_path__ + "static/GNY18-e4e22a45551bbc00794955a2d5082cb5.jpg";